export default __webpack_public_path__ + "static/media/Thief's Belt of the Deceiver.5e42290e.jpg";